import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "rowInfo", "className"],
  _excluded2 = ["children", "droppableClassName"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import _get from 'lodash/get';
import _stubTrue from 'lodash/stubTrue';
import _size from 'lodash/size';
import _noop from 'lodash/noop';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import FORM_ACTION_TYPES from '../FormBuilder/constants/actionTypes';
import ReactTableTRowComponent from '../../atoms/ReactTableRowComponent';
import ReactTableTBodyComponent from '../../atoms/ReactTableBodyComponent';
import { updateDestinationIndex, isDragDropValid, rearrangeRowData } from './withDragNDropTable.helpers';
var DragTrComponent = function DragTrComponent(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    rowInfo = _ref.rowInfo,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!rowInfo) return /*#__PURE__*/React.createElement(ReactTableTRowComponent, _extends({
    className: className
  }, rest), children);
  var index = rowInfo.index,
    original = rowInfo.original;
  var shouldDisableDrag = original.shouldDisableDrag;
  var draggableId = index + 1;
  return /*#__PURE__*/React.createElement(Draggable, {
    index: index,
    draggableId: "".concat(draggableId),
    key: draggableId,
    isDragDisabled: shouldDisableDrag
  }, function (draggableProvided) {
    return /*#__PURE__*/React.createElement("div", _extends({
      ref: draggableProvided.innerRef
    }, draggableProvided.draggableProps, draggableProvided.dragHandleProps), /*#__PURE__*/React.createElement(ReactTableTRowComponent, _extends({
      className: "".concat(className, " full-width")
    }, rest), children));
  });
};
var DropTbodyComponent = function DropTbodyComponent(_ref2) {
  var _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? null : _ref2$children,
    droppableClassName = _ref2.droppableClassName,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Droppable, {
    droppableId: "droppable"
  }, function (droppableProvided) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: droppableClassName,
      ref: droppableProvided.innerRef
    }, droppableProvided.droppableProps), /*#__PURE__*/React.createElement(ReactTableTBodyComponent, rest, children, droppableProvided.placeholder));
  });
};
var withDragNDropTable = function withDragNDropTable(TableComponent) {
  var DragNDropTable = /*#__PURE__*/function (_Component) {
    _inherits(DragNDropTable, _Component);
    var _super = _createSuper(DragNDropTable);
    function DragNDropTable() {
      var _this;
      _classCallCheck(this, DragNDropTable);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function (result) {
        var _this$props = _this.props,
          isFirstRowDefault = _this$props.isFirstRowDefault,
          onAction = _this$props.onAction,
          isDragDropAllowed = _this$props.isDragDropAllowed,
          id = _this$props.id;
        if (!result.destination || !onAction) return;
        var value = _this.props.value;
        var _result$source = result.source,
          source = _result$source === void 0 ? EMPTY_OBJECT : _result$source,
          _result$destination = result.destination,
          destination = _result$destination === void 0 ? EMPTY_OBJECT : _result$destination;
        var sourceIndex = source.index;
        var destinationIndex = destination.index;
        var dragNotAllowed = _get(value, [destinationIndex, 'isDefault'], false);
        destinationIndex = updateDestinationIndex({
          value: value,
          destinationIndex: destinationIndex,
          isFirstRowDefault: isFirstRowDefault
        });
        if (!isDragDropValid({
          value: value,
          sourceIndex: sourceIndex,
          destinationIndex: destinationIndex,
          isFirstRowDefault: isFirstRowDefault,
          dragNotAllowed: dragNotAllowed
        })) return;
        // Supply original source index and destination index here (Don't supply modified indices)
        if (!isDragDropAllowed({
          sourceIndex: source.index,
          destinationIndex: destination.index,
          totalRows: _size(value)
        })) return;
        // Use modified indices here to manipulate row list
        var tableValue = rearrangeRowData({
          value: value,
          sourceIndex: sourceIndex,
          destinationIndex: destinationIndex
        });
        onAction({
          type: FORM_ACTION_TYPES.ON_FIELD_CHANGE,
          payload: {
            id: id,
            value: tableValue,
            draggedRow: {
              sourceIndex: sourceIndex,
              destinationIndex: destinationIndex
            }
          }
        });
      });
      return _this;
    }
    _createClass(DragNDropTable, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          value = _this$props2.value,
          onDragUpdate = _this$props2.onDragUpdate;
        return /*#__PURE__*/React.createElement(DragDropContext, {
          onDragEnd: this.handleDragEnd,
          onDragUpdate: onDragUpdate
        }, /*#__PURE__*/React.createElement(TableComponent, _extends({}, this.props, {
          value: value,
          TrComponent: DragTrComponent,
          TbodyComponent: DropTbodyComponent
        })));
      }
    }]);
    return DragNDropTable;
  }(Component);
  DragNDropTable.propTypes = {
    value: PropTypes.array.isRequired,
    isFirstRowDefault: PropTypes.bool,
    isDragDropAllowed: PropTypes.func,
    onDragUpdate: PropTypes.func,
    onAction: PropTypes.func,
    id: PropTypes.string
  };
  DragNDropTable.defaultProps = {
    isFirstRowDefault: false,
    isDragDropAllowed: _stubTrue,
    onDragUpdate: _noop,
    onAction: _noop,
    id: EMPTY_STRING
  };
  return DragNDropTable;
};
DragTrComponent.propTypes = {
  children: PropTypes.element.isRequired,
  rowInfo: PropTypes.object.isRequired,
  className: PropTypes.string,
  shouldDisableDrag: PropTypes.bool
};
DragTrComponent.defaultProps = {
  className: '',
  shouldDisableDrag: false
};
DropTbodyComponent.propTypes = {
  children: PropTypes.element.isRequired,
  droppableClassName: PropTypes.string
};
DropTbodyComponent.defaultProps = {
  droppableClassName: EMPTY_STRING
};
export default withDragNDropTable;